import { Strong } from 'braid-design-system';
import { useState, useEffect } from 'react';

import { getRemainingTime } from '../../utils/getRemainingTime';

const defaultRemainingTime = {
  seconds: '00',
  minutes: '00',
};

const PER_SECONDS = 1000;

const CountdownTimer = ({
  milliseconds,
  onComplete,
}: {
  milliseconds: number;
  onComplete?: () => void;
}) => {
  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const intervalId: any =
      !complete &&
      setInterval(() => {
        const timeLeft = getRemainingTime(milliseconds);

        if (
          timeLeft.days === '00' &&
          timeLeft.hours === '00' &&
          timeLeft.minutes === '00' &&
          timeLeft.seconds === '00'
        ) {
          setComplete(true);
          clearInterval(intervalId);

          if (onComplete) {
            onComplete();
          }
        }

        setRemainingTime(getRemainingTime(milliseconds));
      }, PER_SECONDS);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span>
      <Strong>
        {remainingTime.minutes}:{remainingTime.seconds}
      </Strong>
    </span>
  );
};

export default CountdownTimer;
